<!--component html goes here -->
<div
  *ngIf="showCookieTerms"
  class="cookie-footer cookie-footer-container text-left"
>
  <div class="container outer-cookie-container">
    <div class="row cookie-row">
      <div class="col-11 p-0 cookie-desc-container" role="alert" tabindex="0">
        <div class="alert-cookie-details">
          <div class="cookie-desc cookie-display-block">
            <p
              class="mb-0 cookie-banner-content"
              innerHTML="{{ cookieDetails?.alertMessage }}"
            >
              .
            </p>
          </div>
        </div>
      </div>
      <div class="close-cookie col-1 pr-0 pl-0">
        <button
          (click)="closeCookieBanner()"
          class="cookie-close-icon float-right circle-outline"
          role="button"
        >
          <span class="sr-only">Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
